import StoreLocatorBase from '../../../common/StoreLocatorBase';
import Helper from '../../../../common/utils/helper';
import SlotTime from "../components/SlotTime.ts";
import Cart from "../pages/hegyd/hegyd-ecommerce/cart";

type cityInfoType = {
    'id': number,
    'name': string,
    'zip': number,
    'department': number,
    'country': string,
    'latitude': string, // or number ?
    'longitude': string, // or number ?
}

type customMarker = google.maps.Marker
    & { info: string }

export default class StoreLocator extends StoreLocatorBase {
    private markersUrl: string;
    CnCModal: HTMLElement | null;
    private suggestions: HTMLUListElement;

    private input: HTMLInputElement;

    private htmlMap: HTMLElement|null;

    private isAppoint: string;

    protected view: HTMLElement;

    constructor(view: HTMLElement) {
        super();
        this.view = view;
    }
    getRdvButtonSelector() {
        return '.take-appointment';
    }
    getCnCModalSelector() {
        return 'driveStep-1';
    }

    init() {
        super.init();
        this.CnCModal = document.getElementById(this.getCnCModalSelector());
        this.htmlMap = document.getElementById('map');
        this.markersUrl = this.htmlMap ? (this.htmlMap.getAttribute('data-markers') ?? '') : '';
        this.isAppoint = this.htmlMap ? (this.htmlMap.getAttribute('data-is-appointment') ?? '') : '';
        this.suggestions = document.querySelector('.suggestions ul') as HTMLUListElement;
        this.input = document.querySelector('#search-agency') as HTMLInputElement;

        this.initSearch();
        this.hideSearchListener();
        this.initGeolocation();
        this.initSuggestionsListener();
    }

    initMarkers(query?: object) {
        const self = this;
        fetch(this.markersUrl, {
            method: 'POST',
            body: JSON.stringify(query || ''),
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, markerList]) => {
                self.deleteMarkers();
                self.addMarkers(markerList);
            });
    }

    initShops(query?: object) {
        const agenciesList = document.querySelector('.agencies-list');
        if (agenciesList) {
            fetch(agenciesList.getAttribute('data-url') ?? '/', {
                method: 'POST',
                body: JSON.stringify(query || ''),
                headers: Helper.createFetchHeader(),
            })
                .then((response) => Promise.all([response, response.text()]))
                .then(([, data]) => {
                    agenciesList.innerHTML = data;
                    document.querySelectorAll(this.getRdvButtonSelector())
                        .forEach((takeAppoint) => {
                            takeAppoint.addEventListener('click', (e) => {
                                e.preventDefault();
                                const cartInstance = new Cart();
                                this.updateModalContent(e.target);
                            });
                        });
                    (() => new StoreLocator(this.CnCModal.querySelector('[data-mount="StoreLocator"]')))();
                });
        }
    }
    updateModalContent(element: HTMLLinkElement, selector: string = '.modal-content'): void {
        fetch(element.getAttribute('href') ?? '/', {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                if (this.CnCModal) {
                    const modalContent = this.CnCModal.querySelector(selector);
                    if (modalContent) {
                        modalContent.innerHTML = data;
                    }
                    this.onUpdateContentModal();
                }
            });
    }
    onUpdateContentModal() {
        if (this.CnCModal !== null) {
            // @ts-ignore  this.CnCModal !== null alors querySelector('[data-mount="StoreLocator"] !== null

            // @ts-ignore idem
            (() => new SlotTime(this.CnCModal.querySelector('[data-mount="SlotTime"]')))();
        }
    }

    initSearch() {
        this.input.value = '';

        this.input.addEventListener('keyup', StoreLocator.delay(() => {
            this.search();
        }, 300));

        this.input.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (this.input.value !== '' && this.input.hasAttribute('data-city') && this.input.getAttribute('data-city') !== '') {
                    this.initMarkers({ city: this.input.getAttribute('data-city') });
                    this.initShops({ city: this.input.getAttribute('data-city') });
                } else {
                    this.initMarkers();
                    this.initShops();
                }
            }
        });
    }

    search() {
        const self = this;
        fetch(this.input.getAttribute('data-autocomplete') ?? '/', {
            method: 'POST',
            body: JSON.stringify({ search: this.input.value }),
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, cities]) => {
                if (JSON.parse(cities).length > 0) {
                    self.showSuggestions(cities);
                }
            });
    }

    initSuggestionsListener() {
        this.suggestions.addEventListener('click', (e) => {
            this.useSuggestion(e);
            this.initMarkers({ city: this.input.getAttribute('data-city') });
            this.initShops({ city: this.input.getAttribute('data-city') });
            this.hideSuggestions();
        });
    }

    useSuggestion(e: Event) {
        const li = (e.target as HTMLLIElement);
        this.input.value = li.innerText;
        this.input.focus();
        this.input.setAttribute('data-city', li.getAttribute('data-id') ?? '');
    }

    showSuggestions(cities: string) {
        // On supprime les <li>
        Helper.removeElementContent(this.suggestions);
        // On remplit mon ul
        JSON.parse(cities).forEach((city:cityInfoType) => {
            const li = document.createElement('li');
            li.setAttribute('data-id', `${city.id}`);
            li.innerText = `${city.name} (${city.department})`;
            this.suggestions.appendChild(li);
        });
        // On affiche la liste
        this.suggestions.classList.add('has-suggestions');
    }

    hideSuggestions() {
        // On masque la liste des suggestions
        this.suggestions.classList.remove('has-suggestions');
        // On supprime les <li>
        Helper.removeElementContent(this.suggestions);
    }

    searchMarkers() {
        const self = this;
        const input = document.querySelector('#search-agency') as HTMLInputElement;
        fetch(this.markersUrl, {
            method: 'POST',
            body: JSON.stringify({ search: input.value }),
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, markerList]) => {
                self.deleteMarkers();
                self.addMarkers(markerList);
            });
    }

    initGeolocation() {
        const geolocationElement = document.querySelector('.geolocation');
        if (geolocationElement) {
            geolocationElement.addEventListener('click', () => {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.initMarkers({ coords: { latitude: position.coords.latitude, longitude: position.coords.longitude } });
                    this.initShops({ coords: { latitude: position.coords.latitude, longitude: position.coords.longitude } });
                });
            });
        }
    }

    static delay(fn: () => void, ms: number) {
        let timer = 0;
        return function anonymous(this: any, ...args: any[]) {
            clearTimeout(timer);
            timer = window.setTimeout(fn.bind(this, ...args), ms || 0);
        };
    }

    hideSearchListener() {
        window.addEventListener('click', (e) => {
            const searchForm = document.querySelector('#search-agency-form');
            if (searchForm && !searchForm.contains(e.target as Node)) {
                this.hideSuggestions();
            }
        });
    }

    initInfoWindow(marker: customMarker) {

        const InfoWindow = new google.maps.InfoWindow({
            content: '',
        });
        marker.addListener('click', () => {
            this.closeCurrentInfoWindow();
            InfoWindow.open(this.map, marker);
            InfoWindow.setContent('Loading...');
            fetch(marker.info, {
                method: 'POST',
                body: JSON.stringify({isAppoint: this.isAppoint }),
                headers: Helper.createFetchHeader(),
            }).then((response) => Promise.all([response, response.text()]))
                .then(([, data]) => {
                    InfoWindow.setContent(data);
                    this.currentInfoWindow = InfoWindow;
                });
        });
    }
}
